import { ConfigState, configState } from './config';
import { PlayerState, playerState } from './player';
import { SettingsState, settingsState } from './settings';
import { VHSState, vhsState } from './vhs';
import { ChromecastState, chromecastState } from './chromecast';
import { ConvivaState, convivaState } from './conviva';
import { VideosState, videosState } from './videos';
import { ErrorState, errorState } from './error';
import { InteractionsState, interactionsState } from './interactions';
import { SubtitlesState, subtitlesState } from './subtitles';

export interface StoreState {
  config: ConfigState;
  videos: VideosState;
  player: PlayerState;
  subtitles: SubtitlesState;
  settings: SettingsState;
  vhs: VHSState;
  conviva: ConvivaState;
  chromecast: ChromecastState;
  interactions: InteractionsState;
  error: ErrorState;
}

export const storeState: StoreState = {
  config: configState,
  videos: videosState,
  player: playerState,
  subtitles: subtitlesState,
  settings: settingsState,
  vhs: vhsState,
  conviva: convivaState,
  chromecast: chromecastState,
  interactions: interactionsState,
  error: errorState,
};
